import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "table table-bordered mb-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "form-group my-4"
}


import type { Receipt } from "@/types/receipt"
import { useReceiptStore } from '@/stores/receipt'
import type { ApiResult } from "@/types/auth"
import Swal from "sweetalert2"
import 'sweetalert2/src/sweetalert2.scss'
import useAuth from "@/use/useAuth"


export default /*@__PURE__*/_defineComponent({
  __name: 'ReceiptDetail',
  props: {
    receiptData: {}
  },
  setup(__props: any) {



const { isSuperAdmin } = useAuth()

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

const { downloadReceipt } = useReceiptStore()

const download = async (receiptNumber: string) => {
  const response: ApiResult = await downloadReceipt(receiptNumber)

  if (response.success) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Receipt is downloaded successfully',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Receipt Details")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", {
                class: "fw-bold bg-light",
                style: {"width":"40%"}
              }, "Receipt Number", -1)),
              _createElementVNode("td", null, _toDisplayString(__props.receiptData.receiptNumber), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Agency Reference", -1)),
              _createElementVNode("td", null, _toDisplayString(__props.receiptData.agencyUniqueReference), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Recipient Name", -1)),
              _createElementVNode("td", null, _toDisplayString(__props.receiptData.recipientName), 1)
            ]),
            (__props.receiptData.recipientEmail)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Recipient Email", -1)),
                  _createElementVNode("td", null, _toDisplayString(__props.receiptData.recipientEmail), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.receiptData.recipientPhone)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Recipient Phone", -1)),
                  _createElementVNode("td", null, _toDisplayString(__props.receiptData.recipientPhone), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Amount", -1)),
              _createElementVNode("td", null, "₵" + _toDisplayString(__props.receiptData.amount), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Fee", -1)),
              _createElementVNode("td", null, "₵" + _toDisplayString(__props.receiptData.fee.toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Agency Name", -1)),
              _createElementVNode("td", null, _toDisplayString(__props.receiptData.agencyName), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Receipt Type", -1)),
              _createElementVNode("td", null, _toDisplayString(__props.receiptData.receiptType), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "fw-bold bg-light" }, "Receipt Date", -1)),
              _createElementVNode("td", null, _toDisplayString(formatDate(__props.receiptData.receiptDate)), 1)
            ])
          ])
        ])
      ])
    ]),
    (_unref(isSuperAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "submit",
            class: "default-btn w-100 d-block",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (download(__props.receiptData.receiptNumber)))
          }, " Download Receipt ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})